<template>
  <div class="container" id="booking">
    <div class="row">
      <div class="col-12">
        <div class="webpage-section-header  text-center" >
          RESERVATION
          <div class="under-bar"></div>
        </div>
      </div>
    </div>
    <div class="row" v-if="merchantItem !== null && merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.booking_message !== undefined && merchantItem.webSetting.booking_message !== null && merchantItem.webSetting.booking_message.length > 0">
      <div class="col-12" v-html="merchantItem.webSetting.booking_message.replace(/\n/g, '<br />')">

      </div>
    </div>
    <div class="row" v-if="bookingTypes.length > 1">
      <div class="col-12 booking-type-container" >
        <div class="booking-type" v-for="type in bookingTypes" v-bind:class="{'selected' : bookingItem !== false && bookingItem.bookingType === type.title}" v-on:click="onTypeSelected(type)">
          <div class="booking-type-title">
            {{type.title}}
          </div>
          <div class="booking-type-description" v-if="type.description !== undefined && type.description !== null && type.description.length > 0">
            {{type.description}}


          </div>
        </div>
      </div>
    </div>
    <template v-if="bookingItem !== false && reservedItem === false">
    <div class="row booking-form-row text-left" >


      <div class="col-12 text-center" v-if="bookingItem.typeList.length > 0">

        <strong>Please select table type</strong>
        <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
          <div v-for="type in bookingItem.typeList" class="round-selector" v-bind:class="{'selected': bookingItem.tableType === type}" v-on:click="selectSubType(type)">{{type}}</div>
        </div>
      </div>

<!--      <template v-if="bookingItem.typeList.length === 0 || (bookingItem.typeList.length > 0 && bookingItem.types.length > 0">-->
      <div class="col-12 col-md-4">
        Date <span v-if="bookingItem !== null && bookingItem !== false && bookingItem.lastDay !== null">(up to {{bookingItem.lastDay}})</span>
        <div class="white-input">
          <date-picker style="width: 100%; "
                       :lang="'en'"
                       class="date-picker"
                       input-class="date-picker"
                       v-model="bookingItem.bookingDate"
                       typable="false"
                       placeholder="Select Date"
                       valueType="format"
                       @change="onBookingDateSelected"></date-picker>
        </div>

        <!--        <input class="form-control" type="date" v-model="bookingItem.bookingDate" v-on:change="onBookingDateSelected"></input>-->
      </div>


      <div class="col-12 col-md-4">
        Number of Guests
        <select class="form-control" v-model="bookingItem.headCount" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null" @change="getAvailabilities">
          <option value="0">
            <span v-if="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">Select Date to get capacity</span>
            <span v-else>Number of Guests </span>
          </option>
          <template v-for="(c, ci) in bookingItem.maxBooking">
            <option v-if="c > 1 && c >= bookingItem.minBooking" :value="c">{{c}} Guests</option>
          </template>
        </select>
        <span v-if="bookingItem.confirmRequiredCount > 0">*{{bookingItem.confirmRequiredCount}} or more guests will require the confirmation of the restaurant.</span>
        <br/>
        <!--        Number of children-->
        <!--        <select class="form-control" v-model="bookingItem.children" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">-->
        <!--          <option value="0">No children-->
        <!--          </option>-->
        <!--          <template v-for="(c, ci) in bookingItem.maxBooking">-->
        <!--            <option v-if="c > 1 && c >= bookingItem.minBooking" :value="c">{{c}}</option>-->
        <!--          </template>-->
        <!--        </select>-->
      </div>
      <div class="col-12 col-md-4">
        Time
        <select class="form-control" v-model="bookingItem.bookingDayTime" @change="getAvailabilities" :disabled="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">
          <option value="0">
            <span v-if="bookingItem.bookingDate === '' || bookingItem.bookingDate === null">Select Date to get time list</span>
            <span v-else>Select Time</span>
          </option>
          <option v-if="bookingItem.slots.length > 0" v-for="slot in bookingItem.slots" :value="slot.text" :disabled="slot.available === false">{{slot.text}}  {{slot.available === false?' Full':''}}</option>
        </select>
      </div>

    </div>

    <div class="row" v-if="slots !== null && slots.length > 0">
      <div v-for="slot in slots" class="col-4 col-md-4 col-lg-3">
        <div class="available-slot-item" @click="onSlotSelected(slot)">{{slot.hhmm}}</div>
      </div>

<!--      <div class="col-12 text-left">-->
<!--        <span v-if="bookingItem.allowMerchantPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="bookingItem.allowMerchantPromotion = !bookingItem.allowMerchantPromotion"><i class="fas fa-check-square"></i></span>-->
<!--        <span v-else style="font-size: 22px;" @click="bookingItem.allowMerchantPromotion = !bookingItem.allowMerchantPromotion"><i class="far fa-square"></i></span>-->
<!--        {{merchantItem.title}} will send you offers or news by email unless you object by unchecking this box.-->
<!--      </div>-->
<!--      <div class="col-12 text-left">-->
<!--        <span v-if="bookingItem.allowSmtmPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="bookingItem.allowSmtmPromotion = !bookingItem.allowSmtmPromotion"><i class="fas fa-check-square"></i></span>-->
<!--        <span v-else style="font-size: 22px;" @click="bookingItem.allowSmtmPromotion = !bookingItem.allowSmtmPromotion"><i class="far fa-square"></i></span>-->
<!--        Show Me The Menu will send you offers and news by email unless you object by unchecking this box.-->
<!--      </div>-->
    </div>

    </template>
    <div class="row booking-form-row text-left" v-if="reservedItem !== false">
      <div class="col-12 text-center">
        This session will be held for 2 minutes.
      </div>
      <div class="col-12" style="font-weight: 600; font-size: 20px; text-align: center;">
        {{reservedItem.bookingTimeLocale}}
        <br/>
        {{reservedItem.headCount}} guests
        <br/>
        Duration : {{reservedItem.duration}} minutes
      </div>
      <div class="col-12 col-md-6">
        Name
        <input class="form-control" type="text" v-model="reservedItem.name" placeholder="Name">
      </div>
      <div class="col-12 col-md-6">
        Mobile Number
        <select class="form-control" v-model="reservedItem.countryCode">
          <option v-for="(c, ci) in countryCodeList" v-bind:key="'booking-table-country-code-' + ci" :value="c.mobileCode">
            {{c.mobileCode}} ({{c.name}})
          </option>
        </select>
        <input type="tel" class="form-control" v-model="reservedItem.phoneNumber" placeholder="Phone number"/>
      </div>
      <div class="col-12 col-md-6">
        Email
        <input class="form-control" type="text" v-model="reservedItem.email" placeholder="Email">
      </div>
      <div class="col-12 col-md-6">
        <div style="margin-top:10px;">Email confirmation</div>
        <input class="form-control" type="text" v-model="reservedItem.emailConfirm" placeholder="Email Confirmation">

        <span style="color:red;">* Incorrect email will prevent us from sending you confirmation or notification email</span>
      </div>
      <div class="col-12 text-left">
        Special Request
        <textarea class="form-control" rows="3" v-model="reservedItem.note"/>
      </div>

      <div class="col-12 text-left">
        <span v-if="reservedItem.allowMerchantPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="reservedItem.allowMerchantPromotion = !reservedItem.allowMerchantPromotion"><i class="fas fa-check-square"></i></span>
        <span v-else style="font-size: 22px;" @click="reservedItem.allowMerchantPromotion = !reservedItem.allowMerchantPromotion"><i class="far fa-square"></i></span>
        {{merchantItem.title}} will send you offers or news by email unless you object by unchecking this box.
      </div>
      <div class="col-12 text-left">
        <span v-if="reservedItem.allowSmtmPromotion === true" style="font-size: 22px; color: #2F77E4;" @click="reservedItem.allowSmtmPromotion = !reservedItem.allowSmtmPromotion"><i class="fas fa-check-square"></i></span>
        <span v-else style="font-size: 22px;" @click="reservedItem.allowSmtmPromotion = !reservedItem.allowSmtmPromotion"><i class="far fa-square"></i></span>
        Show Me The Menu will send you offers and news by email unless you object by unchecking this box.
      </div>
      <div class="col-12 text-center" v-if="reservedItem.deposit > 0">
        <strong>
          <span style="color:red;">Deposit of £{{(reservedItem.deposit/100.0).toFixed(2)}} is required for this date.</span>
          <br/>
          Credit Card Pre Authorisation will be processed after submission.
        </strong>
      </div>
      <div class="col-12 text-center">
        <br/>Your reservation request is sent to the restaurant when you submit.
        <br/>If we do not already know your email address, we will email you a verify button. Please click it when the email arrives, including if it arrives later.
        <br/>Check your spam folder and mark the email as not spam before you click the button.
        <br/>Your reservation is not confirmed until the restaurant accepts it.

      </div>
      <div class="col-12 text-center">
        <button class="btn gray-submit-button" v-bind:class="{'enabled-black': canSubmitBooking(false) === true}" v-on:click="submitBooking" :disabled="submitting">Submit</button>

      </div>
    </div>
    <v-dialog/>
    <div class="page-gif-loader" v-if="submitting">
      <div class="gif-loader">
        <UtensilLoader/>
        <span>Submitting...</span>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import {
  bookingCardDepositPreAuthorise, cancelReservedBooking, getAvailableSlots, getBookingMerchantItem,
  getBookingTimeTable,
  getBookingTypes,
  getHolidayList, getBookingSlots, reserveBooking,
  submitBooking, submitReservedBooking
} from "../api/borium";
import {millisToDate, getCountryCodeList, isValidPhoneNumberInput, buildContactNumber} from "../api/utils";
import EventBus from "../api/event-bus";
import UtensilLoader from "./UtensilLoader";

export default {
  name: "BookingTableView",
  props: {
    merchantItem: {
      type:Object,
      default: function(){return false},
    },
  },
  components: {
    DatePicker,
    UtensilLoader
  },
  data() {
    return {
      bookingItem:false,
      bookingDate:'',
      bookingTime:'',
      bookingDaySchedules: [],
      bookingTypes:[],
      holidays:[],
      stripe:false,
      reservedItem:false,
      slots:[],
      countryCodeList: getCountryCodeList(),
      submitting: false,
    }
  },
  created() {
  },
  mounted() {
    if(this.merchantItem !== false) {
      // console.log("merchant item");
      // console.log(this.merchantItem);
      this.getMerchantInfo();
    }
  },
  methods: {
    intialisePage: function() {
      this.$data.bookingItem = false;
      this.$data.bookingDate = '';
      this.$data.bookingTime = "";
      this.$data.bookingDaySchedules = [];
      this.$data.bookingTypes = [];
      this.$data.holidays = [];
      this.$data.stripe = false;
      this.$data.reservedItem = false;
      this.$data.slots = [];
      this.getMerchantInfo();
    },
    getMerchantInfo: function() {

      let self = this;
      // console.log("get merchant info");
      getBookingMerchantItem(this.merchantItem.merchantId)
        .then(function(data){
          if(data.success === true) {
            self.merchantItem.mId = data.item.id;
            self.getBookingInfo();
          }
        })
    },
    getBookingInfo: function() {
      this.$data.slots = [];
      let self = this;
      getBookingTypes(this.merchantItem.merchantId)
        .then(function(data){
          // console.log("booking type")
          // console.log(data);
          if(data.success === true) {
            self.$data.bookingTypes = data.item;
          }
          self.getBookingTimes();
        })
        .catch(function(err) {

        })
    },
    getBookingTimes: function() {
      let self = this;
      getBookingTimeTable(this.merchantItem.merchantId)
        .then(function(data) {
          if(data.success === true) {
            self.$data.bookingDaySchedules = data.item;
            // console.log(data.item);

            if(self.$data.bookingTypes.length === 1) {
              self.$data.bookingItem = {
                bookingDate:'',
                bookingDayTime:'',
                bookingTime:0,
                bookingType:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].title : '',
                name:'',
                headCount:0,
                children:0,
                email:'',
                emailConfirm:'',
                note:'',
                contact:'',
                subscriptionId:self.merchantItem.merchantId,
                merchantId: self.merchantItem.mId,
                preVerifySubscriptionId: self.merchantItem.merchantId,
                slots:[],
                types:[],
                tableType:'',
                typeList:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].types : [],
                maxBooking: 6,
                minBooking: 2,
                deposit:0,
                cancellableTime:0,
                lastDay:null,
                duration:0,
                confirmRequiredCount:self.$data.bookingTypes.length === 1 ? self.$data.bookingTypes[0].confirmRequiredCount : 0,
                allowMerchantPromotion:true,
                allowSmtmPromotion:true,
              }

              if(self.$data.bookingTypes[0].maxBooking > 0) {
                self.$data.bookingItem.maxBooking = self.$data.bookingTypes[0].maxBooking;
              }
              if(self.$data.bookingTypes[0].minBooking > 0) {
                self.$data.bookingItem.minBooking = self.$data.bookingTypes[0].minBooking;
              }
              if(self.$data.bookingTypes[0].slotLength > 0) {
                let lastDay = new Date();
                lastDay.setDate(lastDay.getDate() + self.$data.bookingTypes[0].slotLength);
                self.$data.bookingItem.lastDay = millisToDate(lastDay.getTime());
              }
            }

            self.getHolidayList();
          }

        })
        .catch(function(err) {

          // console.log(err);
          // if(err.response !== undefined) {
          //   console.log(err.response);
          // }
        })
    },
    getHolidayList: function() {
      // console.log("get holiday list");
      let self = this;
      let today = millisToDate(new Date().getTime(), '-');

      getHolidayList(this.merchantItem.merchantId, today)
        .then(function(data) {
          // console.log("holiday response");
          // console.log(data);
          if(data.success === true) {
            self.$data.holidays = data.item;
          }
        })
        .catch(function(err) {
          // console.log(err);
          // if(err.response !== undefined) {
          //   console.log(err.response);
          // }
        })
    },
    canSubmitBooking: function(showDialog = true) {
      if(this.$data.reservedItem == null || this.$data.reservedItem === false) {

        return false;
      }

      if(this.$data.bookingItem.typeList !== null && this.$data.bookingItem.typeList.length > 0 && (this.$data.bookingItem.types === null || this.$data.bookingItem.types.length === 0)) {
        if(showDialog === true) this.showDialog("Please select booking option");
        return false;
      }
      let todayText = millisToDate();
      if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
        || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00'
        ||this.$data.bookingItem.bookingDate < todayText ) {
        if(showDialog === true) this.showDialog("Date cannot be earlier than today");
        return false;
      }

      if(this.$data.reservedItem.bookingTime === 0) {
        if(showDialog === true) this.showDialog("Please select time");
        return false;
      }

      if(this.$data.reservedItem.name === null || this.$data.reservedItem.name === '' || this.$data.reservedItem.name.length < 2) {
        if(showDialog === true) this.showDialog("Please enter your name");
        return false;
      }
      if(this.$data.reservedItem.headCount === 0) {
        if(showDialog === true) this.showDialog("Please enter number of people");
        return false;
      }
      if(!isValidPhoneNumberInput(this.$data.reservedItem.phoneNumber)) {
        if(showDialog === true) this.showDialog("Please enter phone number");
        return false;
      }
      if(this.$data.reservedItem.email === null || this.$data.reservedItem.email.includes("@") === false) {
        if(showDialog === true) this.showDialog("Please enter correct email address");
        return false;
      }
      if(this.$data.reservedItem.emailConfirm == null || this.$data.reservedItem.emailConfirm.includes("@") === false) {
        if(showDialog === true) this.showDialog("Please enter confirmation email");
        return false;
      }
      if(this.$data.reservedItem.email !== this.$data.reservedItem.emailConfirm) {
        if(showDialog === true) this.showDialog("Email addresses are not matching");
        return false;
      }
      // console.log("submittable")
      return true;
    },
    submitBooking: function() {
      if(this.canSubmitBooking()==false) {
        return;
      }


      this.$data.reservedItem.contact = buildContactNumber(this.$data.reservedItem.countryCode, this.$data.reservedItem.phoneNumber);
      this.submitting = true;
      EventBus.$emit("showLoading", true, "Submitting...");
      let self = this;
      submitReservedBooking(this.$data.reservedItem)
        .then(function(data) {
          self.submitting = false;
          EventBus.$emit("showLoading", false);
          if(data.success === true) {
            let submitted = data.item;
            self.$data.bookingItem = {
              bookingDate:'',
              bookingDayTime:'',
              bookingTime:0,
              name:'',
              headCount:0,
              email:'',
              emailConfirm:'',
              note:'',
              contact:'',
              subscriptionId:self.merchantItem.merchantId,
              merchantId: self.merchantItem.mId,
              preVerifySubscriptionId: self.merchantItem.merchantId,
              slots:[],
              types:[],
              tableType:'',
              typeList:[],
              deposit:0,
              cancellableTime:0,
              duration:0,
              confirmRequiredCount: 0,
              allowMerchantPromotion:true,
              allowSmtmPromotion:true,
            }
            self.$data.reservedItem = false;
            self.showSubmittedBooking(submitted);
            if(submitted && submitted.deposit > 0) {
              self.processToPayDeposit(submitted.id);
              return;
            }
            self.getBookingInfo();
          } else {
            self.showDialog(data.message);
            self.intialisePage();
          }
        })
        .catch(function(err) {
          self.submitting = false;
          EventBus.$emit("showLoading", false);

          // console.log(err);
          // if(err.response !== undefined) {
          //   console.log(err.response);
          // }
          self.showDialog("There was an error. Please check email if you received email.", "Something went wrong!");
        })
    },
    showSubmittedBooking: function(item) {
      const needsVerify = !!(item && item.emailVerified !== true && item.subscriptionId > 0);
      const confirmed = item && item.state === 10;
      const title = needsVerify
        ? 'Booking Submitted'
        : (confirmed ? 'Your booking has been successfully made.' : 'Your booking request has been submitted.');
      this.showDialog(this.buildSubmittedBookingMessage(item, needsVerify, confirmed), title);
    },
    buildSubmittedBookingMessage: function(item, needsVerify, confirmed) {
      const esc = function(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };
      const email = item && item.email ? esc(item.email) : 'your email address';
      let msg = '';
      msg += this.buildSubmittedBookingDetails(item, esc);
      msg += '<div style="font-size:15px;line-height:1.5;color:#444;margin:0 0 16px 0;">';
      if (confirmed) {
        msg += '<p style="margin:0;">A confirmation email is on its way. If the restaurant needs to change the booking, they will let you know.</p>';
      } else {
        msg += '<p style="margin:0;">Your request is with the restaurant. <strong>It is not confirmed</strong> until they accept it. You will get another email when they do.</p>';
      }
      msg += '</div>';
      if (needsVerify) {
        msg += '<div style="background:#fff6e8;border:2px solid #e6a817;border-radius:12px;padding:16px;margin:0 0 16px 0;">';
        msg += '<div style="font-size:12px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#8a5a00;">Action needed</div>';
        msg += '<div style="margin-top:6px;font-size:20px;line-height:1.3;font-weight:700;color:#1b1b1f;">Click Verify email address</div>';
        msg += '<p style="margin:10px 0 0 0;font-size:15px;line-height:1.5;color:#3c3c3b;">We are sending a message to <strong>' + email + '</strong>. Open it and press the <strong>Verify email address</strong> button. You can do this when the email arrives, even if it comes later.</p>';
        msg += '<div style="margin-top:12px;background:#fff;border-radius:8px;padding:10px 12px;font-size:14px;line-height:1.45;color:#3c3c3b;">Look in your spam folder. If it is there, mark it as not spam, then click the button.</div>';
        msg += '</div>';
      }
      if (this.merchantItem && this.merchantItem.contact !== null) {
        const address = esc(this.merchantItem.address).replace(/\n/g, '<br/>');
        msg += '<div style="margin-top:14px;padding-top:12px;border-top:1px solid #eee;font-size:14px;line-height:1.45;color:#555;"><strong>' + esc(this.merchantItem.title) + '</strong><br/>Tel: ' + esc(this.merchantItem.contact) + '<br/>' + address + '</div>';
      }
      return msg;
    },
    buildSubmittedBookingDetails: function(item, esc) {
      if (!item) {
        return '';
      }
      const when = item.bookingTimeLocale || item.bookingDateTime || [item.bookingDate, item.bookingDayTime].filter(Boolean).join(' ');
      const adults = Number(item.headCount) || 0;
      const children = Number(item.children) || 0;
      const infants = Number(item.infants) || 0;
      let guests = '';
      if (adults > 0) {
        guests = adults + (adults === 1 ? ' person' : ' people');
      }
      if (children > 0) {
        guests += (guests ? ' + ' : '') + children + (children === 1 ? ' child' : ' children');
      }
      if (infants > 0) {
        guests += (guests ? ' + ' : '') + infants + (infants === 1 ? ' toddler' : ' toddlers');
      }
      const selection = item.types && item.types.length ? item.types.join(', ') : '';
      let html = '<div style="background:#f7f7f8;border-radius:12px;padding:14px 16px;margin:0 0 16px 0;">';
      html += '<div style="font-size:12px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#666;">Your booking</div>';
      if (when) {
        html += '<div style="margin-top:8px;font-size:18px;line-height:1.3;font-weight:700;color:#1b1b1f;">' + esc(when) + '</div>';
      }
      if (Number(item.duration) > 0) {
        html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">' + esc(item.duration) + ' minutes</div>';
      }
      if (guests) {
        html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">' + esc(guests) + '</div>';
      }
      if (item.name) {
        html += '<div style="margin-top:8px;font-size:15px;color:#3c3c3b;">Name: ' + esc(item.name) + '</div>';
      }
      if (item.bookingType) {
        html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">Booking type: ' + esc(item.bookingType) + '</div>';
      }
      if (selection) {
        html += '<div style="margin-top:4px;font-size:15px;color:#3c3c3b;">Selection: ' + esc(selection) + '</div>';
      }
      if (item.note) {
        html += '<div style="margin-top:8px;font-size:15px;line-height:1.45;color:#3c3c3b;"><strong>Special request</strong><br/>' + esc(item.note) + '</div>';
      }
      if (item.id) {
        html += '<div style="margin-top:8px;font-size:13px;color:#666;">Reference #' + esc(item.id) + '</div>';
      }
      html += '</div>';
      return html;
    },
    processToPayDeposit: function(id) {
      let self = this;
      bookingCardDepositPreAuthorise(id)
        .then(function(data) {
          if(data.success === true) {
            if (data.item && data.item.teyaSessionUrl) {
              window.location.href = data.item.teyaSessionUrl;
              return;
            }
            self.startStripPayment(data.item, data.message);
          } else {
            self.showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
        })
    },
    startStripPayment: function(item, key) {
      // this.$data.stripe = Stripe('pk_test_51HKwg5FVWak6exTyYpcPbHzjlLTXgLzPJBU1hx7FPgImJOB6psptYrcyP53K75Hy6OXvoeTahf91fUzWqzQxlzt7000Vvir4GN');
      // console.log("start stripe payment " + key);
      this.$data.stripe = Stripe(key);
      this.$data.stripe.redirectToCheckout({ sessionId: item.stripeSessionId });

    },
    selectSubType: function(type) {
      this.$data.bookingItem.tableType = type;
      this.$data.bookingItem.types = [type];
      this.$data.slots=[];
      this.getAvailabilities();
      // console.log(this.$data.bookingItem);

    },
    isTypeSelected: function(type) {
      for(let i = 0 ; i < this.$data.bookingItem.types.length ; i++) {
        if(this.$data.bookingItem.types[i] === type) {
          return true;
        }
      }
      return false;
    },
    onTypeSelected: function(type) {
      if(type === this.$data.bookingItem.bookingType) {
        return;
      }
      this.$data.bookingItem = {
        bookingDate:'',
        bookingDayTime:'',
        bookingTime:0,
        bookingType:'',
        name:'',
        headCount:0,
        email:'',
        emailConfirm:'',
        note:'',
        contact:'',
        subscriptionId:this.merchantItem.merchantId,
        merchantId:this.merchantItem.mId,
        preVerifySubscriptionId: this.merchantItem.merchantId,
        slots:[],
        types:[],
        tableType:'',
        typeList:this.$data.bookingTypes.length === 1 ? this.$data.bookingTypes[0].types : [],
        maxBooking: 20,
        deposit:0,
        cancellableTime:0,
        lastDay:null,
        confirmRequiredCount:this.$data.bookingTypes.length === 1 ? this.$data.bookingTypes[0].confirmRequiredCount:0,
        allowMerchantPromotion:true,
        allowSmtmPromotion:true,
      }
      this.$data.bookingItem.bookingType = type.title;
      this.$data.bookingItem.confirmRequiredCount = type.confirmRequiredCount;
      this.$data.bookingItem.bookingDate = "";
      this.$data.bookingItem.slots = [];
      this.$data.bookingItem.bookingTime = 0;
      this.$data.bookingItem.bookingEndTime = 0;
      this.$data.bookingItem.types = [];
      this.$data.bookingItem.deposit = 0;
      this.$data.bookingItem.typeList = type.types;
      this.$data.bookingItem.maxBooking = type.maxBooking > 0?type.maxBooking:20;
      this.$data.bookingItem.minBooking = type.minBooking > 0?type.minBooking:2;
      this.$data.bookingItem.cancellableTime = 0;
      this.$data.bookingItem.lastDay = null;

      if(type.slotLength > 0) {
        let lastDay = new Date();
        lastDay.setDate(lastDay.getDate() + type.slotLength);
        this.$data.bookingItem.lastDay = millisToDate(lastDay.getTime());
      }

    },

    onBookingDateSelected: function() {
      if(this.$data.bookingItem.bookingDate === undefined || this.$data.bookingItem.bookingDate === null
        || this.$data.bookingItem.bookingDate === '' || this.$data.bookingItem.bookingDate === '0000-00-00') {
        this.$data.bookingItem.bookingDate = "";
        return false;
      }
      this.$data.bookingItem.slots = [];
      this.$data.bookingItem.bookingTime = 0;
      this.$data.bookingItem.bookingDayTime = '';
      this.$data.bookingItem.bookingEndTime = 0;
      this.$data.slots = [];
      this.loadLondonSlots();
    },
    loadLondonSlots: function() {
      let self = this;
      getBookingSlots(this.merchantItem.merchantId, this.$data.bookingItem.bookingDate, this.$data.bookingItem.bookingType)
        .then(function(data) {
          if(data.success !== true || data.item == null) {
            self.$data.bookingItem.bookingDate = '';
            self.$data.bookingItem.slots = [];
            self.showDialog(data.message || "This date is not available");
            return;
          }
          let list = data.item;
          self.$data.bookingItem.slots = list.slots || [];
          if(list.minBooking > 0) {
            self.$data.bookingItem.minBooking = list.minBooking;
          }
          if(list.maxBooking > 0) {
            self.$data.bookingItem.maxBooking = list.maxBooking;
          }
          if(list.deposit > 0) {
            self.$data.bookingItem.deposit = list.deposit;
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
          self.$data.bookingItem.bookingDate = '';
          self.showDialog("There was an error. Please try again.");
        })
    },
    getAvailabilities: function() {
      this.$data.slots = [];
      if(this.$data.bookingItem.bookingDate === null || this.$data.bookingItem.bookingDate === '0000-00-00') {
        return;
      }
      if(this.$data.bookingItem.headCount <= 0) {
        return;
      }
      if(this.$data.bookingItem.bookingDayTime === null || this.$data.bookingItem.bookingDayTime.length === 0 || this.$data.bookingItem.bookingDayTime === '0') {
        return;
      }
      if(this.$data.bookingItem.confirmRequiredCount > 0 && this.$data.bookingItem.confirmRequiredCount <= this.$data.bookingItem.headCount) {
        this.$data.bookingItem.confirmationRequired = true;
      } else {
        this.$data.bookingItem.confirmationRequired = false;
      }
      let self = this;
      let qs = [];
      if(this.$data.bookingItem.bookingType !== null && this.$data.bookingItem.bookingType.length > 0) {
        qs.push("bookingType=" + this.$data.bookingItem.bookingType);
      }
      if(this.$data.bookingItem.tableType !== null && this.$data.bookingItem.tableType.length > 0) {
        qs.push("tableType=" + this.$data.bookingItem.tableType);
      }
      let query = null;
      if(qs.length > 0) {
        query = qs.join('&');
      }
      getAvailableSlots(this.$data.bookingItem.merchantId, this.$data.bookingItem.headCount, this.$data.bookingItem.bookingDate, this.$data.bookingItem.bookingDayTime, query)
        .then(function(data) {
          if(data.success === true) {
            self.$data.slots = data.item;
          } else {
            self.showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
        })
    },
    timeSelected: function() {
      this.$data.bookingItem.cancellableTime = 0;
      for(let i = 0 ; i < this.$data.bookingItem.slots.length ; i++) {
        if(this.$data.bookingItem.bookingTime === this.$data.bookingItem.slots[i].time) {
          this.$data.bookingItem.cancellableTime = this.$data.bookingItem.slots[i].cancellableTime;
          this.$data.bookingItem.length = this.$data.bookingItem.slots[i].length;
          this.$data.bookingItem.bookingEndTime = this.$data.bookingItem.bookingTime+(this.$data.bookingItem.slots[i].length*60000);
          return;
        }
      }
    },
    showDialog: function(message, title = '') {
      let params = {
        title:title,
        text:message
      }
      this.$modal.show('dialog', params);
    },
    cancelReservation: function() {
      if(this.$data.reservedItem === false) {
        return;
      }

      let self = this;
      cancelReservedBooking(this.$data.reservedItem.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.reservedItem = false;
          } else {
            self.showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
        })
    },
    onSlotSelected: function(slot) {
      this.$data.bookingItem.cancellableTime = 0;
      this.$data.bookingItem.duration = slot.duration/60000;
      this.$data.bookingItem.bookingDayTime = slot.hhmm;
      this.$data.bookingItem.bookingTime = slot.time;
      this.$data.bookingItem.bookingEndTime = slot.endTime;

      // console.log("slot selected");
      // console.log(this.$data.bookingItem);


      let self = this;
      reserveBooking(this.$data.bookingItem)
        .then(function(data) {
          if(data.success === true) {
            data.item.emailConfirm = '';
            data.item.countryCode = '+44';
            data.item.phoneNumber = '';
            self.$data.reservedItem = data.item;
          } else {
            self.showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
        })
      // for(let i = 0 ; i < this.$data.bookingItem.slots.length ; i++) {
      //   if(this.$data.bookingItem.bookingTime === slot.time) {
      //     // this.$data.bookingItem.cancellableTime = slot.cancellableTime;
      //     this.$data.bookingItem.length = slot.length;
      //     this.$data.bookingItem.bookingEndTime = this.$data.bookingItem.bookingTime+(this.$data.bookingItem.slots[i].length*60000);
      //     return;
      //   }
      // }
    }
  }
}
</script>

<style scoped>
.available-slot-item {
  background: #E8F7E7;
  /* Main Colour/Black */

  border: 1px solid #000000;
  padding:15px;
  color: #000;
  margin-top:10px;
  margin-bottom:10px;
  font-weight: 500;
  font-size: 18px;
  line-height: 35px;
}

.booking-form-row input, select, select:disabled {
  height: 62px;
  line-height: 62px;
  border: none;
  background-color: white;

}
.white-input {
  height: 62px;
  background-color: #FFF;
  padding:12px 0;


}
.booking-form-row textarea {
  border: none;
}
.date-picker {
  //height: 62px;
  //line-height: 62px;
  //width: 100%;
  border: none;
  padding-left: 10px;
  background-color: white;
}

.gray-submit-button {
  background: #ABABAB;
  color: white;
  border-radius: unset;
  padding: 18px 84px;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.1em;
}
.enabled-black {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingTableView.vue